import axios from "axios";
import store from '../store';
export function formatDate(datetime, type) {
    // 获取年月日时分秒值  slice(-2)过滤掉大于10日期前面的0

    var year = datetime.getFullYear(),
        month = ("0" + (datetime.getMonth() + 1)).slice(-2),
        date = ("0" + datetime.getDate()).slice(-2),
        hour = ("0" + datetime.getHours()).slice(-2),
        minute = ("0" + datetime.getMinutes()).slice(-2),
        second = ("0" + datetime.getSeconds()).slice(-2);
    // 拼接
    if (type == 1) {
        var result = year + "-" + month + "-" + date
    } else {
        var result = year + "-" + month + "-" + date + " " + hour + ":" + minute + ":" + second;
    }

    // 返回
    return result;
}

export function getsubscribeStatus(openid) {
    if (openid && openid !== 'null') {
        axios
            .get(`https://partnersocial.intel.cn/api/sso/user/subscribeStatus?openid=${window.localStorage.getItem('openid')}`)
            .then(res => {
                if (res.data.data == "0") {
                    store.dispatch('setSAMLResponse', { subscribeStatus: false });
                    window.localStorage.setItem('subscribeStatus', false)
                } else if (res.data.data == "1") {
                    window.localStorage.setItem('subscribeStatus', true)
                    store.dispatch('setSAMLResponse', { subscribeStatus: true });
                }
            })
    }
}
export function formatUser() {
    if (window.localStorage.getItem("memberOf") == '1') {
        store.dispatch('setuserData', { memberOf: '超级管理员' })
    } else if (window.localStorage.getItem("memberOf") == '2') {
        store.dispatch('setuserData', { memberOf: '培训管理员' })
    } else if (window.localStorage.getItem("memberOf") == '3') {
        store.dispatch('setuserData', { memberOf: 'PM' })
    } else if (window.localStorage.getItem("memberOf") == '4') {
        store.dispatch('setuserData', { memberOf: 'Agent' })
    }
}


// WEBPACK FOOTER //
// ./src/util/index.js